import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import { Badge, Tooltip, OverlayTrigger, Dropdown, Button } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import StatusApprove from '../../../modal/Subscription_Management/Manage_Subscriptions/StatusApprove';
import lunch_box from '../../../../images/product/meals_box.png';
import dinner_box from '../../../../images/product/dinner_box.png';
import swal from "sweetalert2";
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Drawer from '@mui/material/Drawer';

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
          diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff)); 
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
          diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};

const Hold = () => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);

    // page table data fetch
    const fetchData = (filter = {}) => {
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch_id: branch_id
        };
        axios.get(`${baseURL}/subscription/mange_hold`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);

    const onInit = () => {};

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const [selectedoption, setselectedoption] = useState({});
   
    const status_approve = (data) => {
        setselectedoption(data);
        setModalType("status_approve");
        setOpen(true);
    };
    const tableRef = useRef(null);
    const [filterOpen, setFilterOpen] = useState(false);
    const onClose = () => {
        setFilterOpen(false);
    };

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const status_cancel = (data) => {
        swal.fire({
            html: `
                <div class=" alert alert-primary px-2 py-2 text-black " role="alert" style="background-color:#D1FFDB; border:1px solid #D1FFDB;">
                            <strong class="pe-1 ">Hurray!! </strong>Your About To Reactive the Subscription  
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                        <p class="text-center"><b>${data.lead_name} - ${data.lead_mobile_no}</b></p>
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" id="stars"  width="48" height="48">
                                <defs>
                                    <linearGradient id="b" x1="256" x2="256" y1="487.916" y2="40.466" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#ffe2a9" stop-opacity=".5"></stop>
                                    <stop offset=".289" stop-color="#ffe09e" stop-opacity=".5"></stop>
                                    <stop offset=".653" stop-color="#ffd97f" stop-opacity=".5"></stop>
                                    <stop offset="1" stop-color="#ffcf54" stop-opacity=".5"></stop>
                                    </linearGradient>
                                    <linearGradient id="d" x1="256" x2="256" y1="486.916" y2="41.466" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#de932c"></stop>
                                    <stop offset=".088" stop-color="#e6a236"></stop>
                                    <stop offset=".242" stop-color="#f1b643"></stop>
                                    <stop offset=".417" stop-color="#f9c44d"></stop>
                                    <stop offset=".632" stop-color="#fecd52"></stop>
                                    <stop offset="1" stop-color="#ffcf54"></stop>
                                    </linearGradient>
                                    <linearGradient id="e" x1="256" x2="256" y1="434.797" y2="256.367" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#464144"></stop>
                                    <stop offset=".33" stop-color="#383436"></stop>
                                    <stop offset=".709" stop-color="#231f20"></stop>
                                    </linearGradient>
                                    <linearGradient id="f" x1="89.916" x2="422.084" y1="345.582" y2="345.582" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#ffdd90" stop-opacity=".5"></stop>
                                    <stop offset="1" stop-color="#ffd263" stop-opacity=".5"></stop>
                                    </linearGradient>
                                    <linearGradient id="h" x1="6379.772" x2="6379.772" y1="307.443" y2="226.442" gradientTransform="rotate(180 3317.886 273.55)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#d1d0d0"></stop>
                                    <stop offset=".334" stop-color="#f2f2f2"></stop>
                                    <stop offset=".518" stop-color="#fff"></stop>
                                    </linearGradient>
                                    <linearGradient id="i" x1="254.5" x2="254.5" y1="460.759" y2="392.506" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#ad3446"></stop>
                                    <stop offset=".214" stop-color="#d43b50"></stop>
                                    <stop offset=".397" stop-color="#ef3f57"></stop>
                                    <stop offset=".505" stop-color="#f94159"></stop>
                                    <stop offset=".641" stop-color="#ed3f56"></stop>
                                    <stop offset=".886" stop-color="#ce394e"></stop>
                                    <stop offset="1" stop-color="#bd364a"></stop>
                                    </linearGradient>
                                    <linearGradient id="j" x1="78.325" x2="221.198" y1="240.676" y2="97.804" gradientTransform="rotate(-5.635 162.482 147.133)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#2182e2"></stop>
                                    <stop offset="0" stop-color="#3d76cf"></stop>
                                    <stop offset=".001" stop-color="#5c68ba"></stop>
                                    <stop offset=".001" stop-color="#785da7"></stop>
                                    <stop offset=".001" stop-color="#8e5398"></stop>
                                    <stop offset=".002" stop-color="#9f4c8d"></stop>
                                    <stop offset=".003" stop-color="#aa4785"></stop>
                                    <stop offset=".003" stop-color="#b14480"></stop>
                                    <stop offset=".006" stop-color="#b3437f"></stop>
                                    <stop offset="1" stop-color="#5b3671"></stop>
                                    </linearGradient>
                                    <linearGradient id="a" x1="87.161" x2="204.281" y1="240.507" y2="88.615" gradientTransform="rotate(-5.635 162.482 147.133)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#c49be8"></stop>
                                    <stop offset=".083" stop-color="#bb8ce5"></stop>
                                    <stop offset=".344" stop-color="#a261db"></stop>
                                    <stop offset=".579" stop-color="#8f42d4"></stop>
                                    <stop offset=".778" stop-color="#842fd0"></stop>
                                    <stop offset=".916" stop-color="#8028ce"></stop>
                                    </linearGradient>
                                    <linearGradient id="k" x1="77.731" x2="220.604" y1="240.618" y2="97.745" gradientTransform="scale(-1 1)rotate(-5.635 -93.66 5351.83)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#2182e2"></stop>
                                    <stop offset="0" stop-color="#3d76cf"></stop>
                                    <stop offset=".001" stop-color="#5c68ba"></stop>
                                    <stop offset=".001" stop-color="#785da7"></stop>
                                    <stop offset=".001" stop-color="#8e5398"></stop>
                                    <stop offset=".002" stop-color="#9f4c8d"></stop>
                                    <stop offset=".003" stop-color="#aa4785"></stop>
                                    <stop offset=".003" stop-color="#b14480"></stop>
                                    <stop offset=".006" stop-color="#b3437f"></stop>
                                    <stop offset="1" stop-color="#5c3773"></stop>
                                    </linearGradient>
                                    <linearGradient xlink:href="#a" id="l" x1="79.998" x2="219.368" y1="233.597" y2="94.228" gradientTransform="scale(-1 1)rotate(-5.635 -93.66 5351.83)"></linearGradient>
                                    <clipPath id="c">
                                    <path fill="none" stroke="url(#b)" stroke-miterlimit="10" stroke-width="2" d="M478.725 264.191c0 123.008-99.717 222.725-222.725 222.725S33.275 387.2 33.275 264.191 132.992 41.466 256 41.466s222.725 99.718 222.725 222.725Z"></path>
                                    </clipPath>
                                    <clipPath id="g">
                                    <path fill="none" d="M420.084 286.553c0 84.639-79.107 148.244-164.084 148.244S91.916 371.192 91.916 286.553c0-20.998 110.515-30.186 164.084-30.186 53.62 0 164.084 9.188 164.084 30.186Z"></path>
                                    </clipPath>
                                </defs>
                                <g clip-path="url(#c)">
                                    <path fill="url(#d)" d="M478.725 264.191c0 123.008-99.717 222.725-222.725 222.725S33.275 387.2 33.275 264.191 132.992 41.466 256 41.466s222.725 99.718 222.725 222.725Z"></path>
                                </g>
                                <path fill="none" stroke="url(#b)" stroke-miterlimit="10" stroke-width="2" d="M478.725 264.191c0 123.008-99.717 222.725-222.725 222.725S33.275 387.2 33.275 264.191 132.992 41.466 256 41.466s222.725 99.718 222.725 222.725Z"></path>
                                <path fill="url(#e)" d="M420.084 286.553c0 84.639-79.107 148.244-164.084 148.244S91.916 371.192 91.916 286.553c0-20.998 110.515-30.186 164.084-30.186 53.62 0 164.084 9.188 164.084 30.186Z"></path>
                                <path fill="url(#f)" d="M256 256.367c53.62 0 164.084 9.188 164.084 30.186 0 84.639-79.107 148.244-164.084 148.244S91.916 371.192 91.916 286.553c0-20.998 110.515-30.186 164.084-30.186m0-2c-25.847 0-67.539 2.238-102.414 7.24-18.773 2.69-33.647 5.88-44.21 9.478-13.094 4.46-19.46 9.52-19.46 15.468 0 40.667 18.063 78.798 50.862 107.37 31.278 27.247 73.275 42.875 115.222 42.875s83.944-15.628 115.222-42.875c32.799-28.572 50.862-66.703 50.862-107.37 0-5.948-6.363-11.008-19.453-15.468-10.56-3.598-25.43-6.787-44.198-9.479-34.868-5-76.571-7.239-102.433-7.239Z"></path>
                                <g clip-path="url(#g)">
                                    <path fill="url(#h)" d="M105.228 291.025a131.333 131.333 0 0 1 1.075-16.81A38.02 38.02 0 0 1 141.3 241.2c27.764-2.006 202.481-2.078 229.476-.084a38.023 38.023 0 0 1 34.91 33.008 131.325 131.325 0 0 1 1.086 16.901c0 20.613-98.674 29.634-151.263 29.634-52.638 0-150.281-9.02-150.281-29.634Z"></path>
                                    <path fill="url(#i)" d="M333.54 416.49a106.742 106.742 0 0 1-.874 13.663 30.9 30.9 0 0 1-28.443 26.832c-22.565 1.63-6.353 3.774-47.824 3.774-43.12 0-29.743-2.085-51.683-3.706a30.903 30.903 0 0 1-28.373-26.827 106.736 106.736 0 0 1-.883-13.737c0-15.62 27.711-23.983 71.794-23.983 5.176 0 3.657 4.08 8.746 4.08 5.392 0 4.33-4.071 9.945-4.071 44.035 0 67.595 8.401 67.595 23.974Z"></path>
                                    <path fill="#7d2b39" d="M256.532 396.585a71.48 71.48 0 0 1 0 29.62 71.474 71.474 0 0 1 0-29.62Z" opacity=".19"></path>
                                </g>
                                <path fill="url(#j)" d="M115.736 126.869s-41.877 5.098-66.652 10.35c0 0-.003 4.236.136 7.335.11 2.422.462 4.682 2.275 6.027 20.284 15.145 50.754 37.816 50.754 37.816-.024.002-4.042 29.86-6.693 55.043-.207 2.277-.818 11.44 2.938 13.672a5.927 5.927 0 0 0 6.426-.298c20.683-14.615 51.657-36.581 51.657-36.581s34.68 15.488 57.787 25.795a6.01 6.01 0 0 0 6.395-.98c2.6-1.918 2.639-11.02 1.98-13.199-7.522-24.19-19.068-53.459-19.068-53.459s25.451-28.189 42.388-46.97a8.523 8.523 0 0 0 2.374-6.101 40.477 40.477 0 0 0-.882-7.216c-25.326-.333-69.132 2.58-69.132 2.58s-18.965-32.9-31.604-54.835a6.039 6.039 0 0 0-5.763-2.959 5.954 5.954 0 0 0-5.038 4.025c-8.121 23.983-20.278 59.955-20.278 59.955Z"></path>
                                <path fill="url(#a)" d="M115.736 118.33s-37.14 7.864-61.915 13.116a6.01 6.01 0 0 0-4.6 4.57 5.91 5.91 0 0 0 2.274 6.027c20.284 15.145 50.754 37.816 50.754 37.816-.024.002-4.027 37.749-6.677 62.932a6.016 6.016 0 0 0 2.922 5.783 5.927 5.927 0 0 0 6.426-.298c20.683-14.616 51.657-36.582 51.657-36.582s34.68 15.488 57.787 25.795a5.951 5.951 0 0 0 8.12-7.208c-7.523-24.191-18.813-60.43-18.813-60.43s25.451-28.188 42.388-46.97a6.024 6.024 0 0 0 1.05-6.39 5.954 5.954 0 0 0-5.391-3.56c-25.326-.333-63.299-.786-63.299-.786s-18.965-32.9-31.604-54.835a6.039 6.039 0 0 0-5.763-2.96 5.954 5.954 0 0 0-5.038 4.026c-8.121 23.982-20.278 59.954-20.278 59.954Z"></path>
                                <path fill="url(#k)" d="M376.87 66.914a5.954 5.954 0 0 0-5.038-4.025 6.039 6.039 0 0 0-5.763 2.96c-12.64 21.934-31.604 54.835-31.604 54.835s-43.806-2.914-69.132-2.582a40.477 40.477 0 0 0-.882 7.217 8.523 8.523 0 0 0 2.374 6.101c16.937 18.781 42.389 46.97 42.389 46.97s-11.546 29.268-19.069 53.46c-.658 2.178-.62 11.28 1.98 13.199a6.01 6.01 0 0 0 6.395.979c23.107-10.307 57.788-25.795 57.788-25.795s30.973 21.966 51.656 36.581a5.927 5.927 0 0 0 6.426.298c3.756-2.233 3.145-11.395 2.938-13.672-2.65-25.182-6.669-55.04-6.693-55.043 0 0 30.47-22.67 50.755-37.816 1.812-1.345 2.165-3.605 2.274-6.027.14-3.099.136-7.335.136-7.335-24.775-5.252-66.652-10.35-66.652-10.35s-12.157-35.972-20.277-59.955Z"></path>
                                <path fill="url(#l)" d="M376.87 58.376a5.954 5.954 0 0 0-5.038-4.025 6.039 6.039 0 0 0-5.763 2.959c-12.64 21.934-31.604 54.836-31.604 54.836s-37.972.452-63.299.785a5.954 5.954 0 0 0-5.39 3.56 6.024 6.024 0 0 0 1.049 6.39c16.937 18.782 42.389 46.97 42.389 46.97s-11.291 36.239-18.813 60.43a5.951 5.951 0 0 0 8.12 7.208c23.106-10.307 57.787-25.795 57.787-25.795s30.973 21.966 51.656 36.582a5.927 5.927 0 0 0 6.426.298 6.016 6.016 0 0 0 2.923-5.783c-2.651-25.183-6.654-62.93-6.678-62.932 0 0 30.47-22.671 50.754-37.816a5.91 5.91 0 0 0 2.275-6.027 6.01 6.01 0 0 0-4.6-4.57c-24.776-5.252-61.916-13.116-61.916-13.116s-12.157-35.972-20.277-59.954Z"></path>
                            </svg>
                        </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, Reactive It !!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-primary border border-primary',
                htmlContainer: 'text-left'  
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
        if (result.isConfirmed) {
            axios.post(`${baseURL}/subscription/cancel_hold/${data.sno}`)
            .then(response => {
                toast.success("Hold Cancel Successfully!");
                fetchData();
            }).catch(error => {
                console.log(error);
                toast.error("Hold Cancel Failed");
            });
        } 
        });
    };

    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // ------------------------------------------------ filter --------------------------------------
    // prods option & on select
    const [filter_prods_id, setFilterProdsID] = useState(null);
    const [productsOpt, setProductsOpt] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/manage-products/products/active`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.product_name,
                }));
                const allOption = { value: null, label: "All" };
                setProductsOpt([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    // timeline option & on select
    const [filter_tline_id, setFilterTlineID] = useState(null);
    const [timelineoptions, setTimelineoption] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/package-timeline/active`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.packagetimeline_name,
                }));
                const allOption = { value: null, label: "All" };
                setTimelineoption([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    //area
    const [areaOption, setAreaOption] = useState([]);
    const [area, setArea] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`, {params: {branch_id}});
                const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.area_name,
                }));
                const allOption = { value: null, label: "All" };
                setAreaOption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // delivery point
    const [dppoption, setdpoption] = useState([]);
    const [dp, setDp] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/deliverypoint`, {params: {branch_id}});
                const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.delivery_point,
                }));
                const allOption = { value: null, label: "All" };
                setdpoption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const handleGoClick = () => {
        
        const filter = {
            product: filter_prods_id || '',
            timeline: filter_tline_id || '',
            area: area || '',
            delivery_point: dp || '',
            date_filter: date_fil_selt_value || '',
        };
        if (date_fil_selt_value === 'custom') {
            filter.start_date = custom_stdt_fil_value || '';
            filter.end_date = custom_eddt_fil_value || '';
        }
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }        
        fetchData(filter);
        onClose();
    };

    // ------------------------------------------------- export --------------------------------------
    const exportCSV = async () => {
        try {
            const filter = {
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                area: area || '',
                delivery_point: dp || '',
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
            };

            const response = await axios.get(`${baseURL}/subscription/mange_hold`, { params });
            const allData = response.data.data;

            const columnNames = [
                'S.No', 'Subscriber Name', 'Mobile No', 'Email ID', 
                'Area', 'Address', 'Product', 'Start Date', 'End Date', 'Hold Dates', 'Hold Reason'
            ];
            const formattedData = allData.map((item, index) => {
                let lastDates = '-';
                let lastReason = '-';

                if (item.hold_details) {
                    try {
                        const holdDetails = JSON.parse(item.hold_details);
                        if (Array.isArray(holdDetails) && holdDetails.length > 0) {
                            const lastElement = holdDetails[holdDetails.length - 1];
                            lastDates = lastElement.date ? lastElement.date.join(', ') : '-';
                            lastReason = lastElement.reason || '-';
                        }
                    } catch (e) {
                        // JSON parse error, keep defaults
                        console.warn("Invalid hold_details JSON", e);
                    }
                }

                return {
                    'S.No': index + 1,
                    'Subscriber Name': item.lead_name,
                    'Mobile No': item.lead_mobile_no,
                    'Email ID': item.lead_email_id || '-',
                    'Area': item.arearelation?.area_name || '-',
                    'Address': item.address || '-',
                    'Product': item.product_name || '-',
                    'Start Date': formatDate(item.start_date),
                    'End Date': formatDate(item.end_date),
                    'Hold Dates': lastDates,
                    'Hold Reason': lastReason,
                };
            });
            const csv = Papa.unparse({
                fields: columnNames,
                data: formattedData
            });
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'hold.csv';
            link.click();
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const exportExcel = async () => {
        try {

            const filter = {
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                area: area || '',
                delivery_point: dp || '',
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
            };

            const response = await axios.get(`${baseURL}/subscription/mange_hold`, { params });
            const allData = response.data.data;
            
            // Format the data to include the desired columns
            
            const formattedData = allData.map((item, index) => {
                let lastDates = '-';
                let lastReason = '-';

                if (item.hold_details) {
                    try {
                        const holdDetails = JSON.parse(item.hold_details);
                        if (Array.isArray(holdDetails) && holdDetails.length > 0) {
                            const lastElement = holdDetails[holdDetails.length - 1];
                            lastDates = lastElement.date ? lastElement.date.join(', ') : '-';
                            lastReason = lastElement.reason || '-';
                        }
                    } catch (e) {
                        // JSON parse error, keep defaults
                        console.warn("Invalid hold_details JSON", e);
                    }
                }

                return {
                    'S.No': index + 1,
                    'Subscriber Name': item.lead_name,
                    'Mobile No': item.lead_mobile_no,
                    'Email ID': item.lead_email_id || '-',
                    'Area': item.arearelation?.area_name || '-',
                    'Address': item.address || '-',
                    'Product': item.product_name || '-',
                    'Start Date': formatDate(item.start_date),
                    'End Date': formatDate(item.end_date),
                    'Hold Dates': lastDates,
                    'Hold Reason': lastReason,
                };
            });
        
            // Create worksheet from formatted data
            const ws = XLSX.utils.json_to_sheet(formattedData);
        
            // Create a new workbook and append the worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
            // Write the workbook to an Excel file and trigger the download
            XLSX.writeFile(wb, 'hold.xlsx');
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const print = async () => {
        try{
            const filter = {
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                area: area || '',
                delivery_point: dp || '',
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
            };

            const response = await axios.get(`${baseURL}/subscription/mange_hold`, { params });
            const allData = response.data.data;
            // Define the column names for printing
            const columnNames = [
                'S.No', 'Subscriber Name', 'Mobile No', 'Email ID', 
                'Area', 'Address', 'Product', 'Start Date', 'End Date', 'Hold Dates', 'Hold Reason'
            ];
            // const formattedData = allData.map((item, index) => ({
            //     'S.No': index + 1,
            //     'Subscriber Name': item.lead_name,
            //     'Mobile No': item.lead_mobile_no,
            //     'Email ID': item.lead_email_id || '-',
            //     'Area': item.arearelation.area_name || '-',
            //     'Address': item.address || '-',
            //     'Product': item.product_name || '-',
            //     'Start Date': formatDate(item.start_date),
            //     'End Date': formatDate(item.end_date),
            // }));

            const formattedData = allData.map((item, index) => {
                let lastDates = '-';
                let lastReason = '-';

                if (item.hold_details) {
                    try {
                        const holdDetails = JSON.parse(item.hold_details);
                        if (Array.isArray(holdDetails) && holdDetails.length > 0) {
                            const lastElement = holdDetails[holdDetails.length - 1];
                            lastDates = lastElement.date ? lastElement.date.join(', ') : '-';
                            lastReason = lastElement.reason || '-';
                        }
                    } catch (e) {
                        // JSON parse error, keep defaults
                        console.warn("Invalid hold_details JSON", e);
                    }
                }

                return {
                    'S.No': index + 1,
                    'Subscriber Name': item.lead_name,
                    'Mobile No': item.lead_mobile_no,
                    'Email ID': item.lead_email_id || '-',
                    'Area': item.arearelation?.area_name || '-',
                    'Address': item.address || '-',
                    'Product': item.product_name || '-',
                    'Start Date': formatDate(item.start_date),
                    'End Date': formatDate(item.end_date),
                    'Hold Dates': lastDates,
                    'Hold Reason': lastReason,
                };
            });


            // Create an HTML table for printing
            let printContent = `<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
                <thead>
                    <tr style="background-color: #f2f2f2;">`;

            // Add column headers
            columnNames.forEach(col => {
                printContent += `<th style="padding: 8px; text-align: left; border: 1px solid #ddd;">${col}</th>`;
            });

            printContent += `</tr></thead><tbody>`;

            // Add the rows of data
            formattedData.forEach(row => {
                printContent += `<tr>`;
                columnNames.forEach(col => {
                    printContent += `<td style="padding: 8px; border: 1px solid #ddd;">${row[col]}</td>`;
                });
                printContent += `</tr>`;
            });

            printContent += `</tbody></table>`;

            // Open the print dialog
            const printWindow = window.open('', '', 'height=800,width=1000');
            printWindow.document.write('<html><head><title>Lead Details</title>');
            printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; }</style>');
            printWindow.document.write('</head><body>');
            printWindow.document.write(printContent);
            printWindow.document.write('</body></html>');
            printWindow.document.close(); // Necessary for IE >= 10
            printWindow.print();
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Hold</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Subscription Management</li>
                    </ol>
                </div>
                <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                    <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            variant="primary"
                            className="btn btn-primary text-white btn-sm"
                            id="tp-btn"
                        >
                            <span className='me-2'><i class="fa-solid fa-circle-down fs-8"></i></span>
                            <span className=''>Export</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={exportCSV} className='px-2'>
                                <img
                                    src={csv_ico}
                                    alt="CSV"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                            </Dropdown.Item>
                            <Dropdown.Item onClick={exportExcel} className='px-2'>
                                <img
                                    src={excel_ico}
                                    alt="Excel"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                            </Dropdown.Item>
                            <Dropdown.Item onClick={print} className='px-2'>
                                <img
                                    src={print_ico}
                                    alt="Print"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    
                </div>
                
                {open && modalType === "status_approve" && (
                    <StatusApprove show={open} onClose={() => setOpen(false)} data={selectedoption} refresh={fetchData} />
                )}
            </div>

            <div className="table-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>

                <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px'>Subscribers</th>
                            <th className='min-w-100px'>Products</th>
                            <th className='min-w-100px'>Duration</th>
                            <th className='min-w-100px'>Hold</th>
                            <th className='min-w-125px text-center'>Reason</th>
                            <th className='min-w-125px text-center'>Status</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {datas.length === 0 && hasFetched ? (
                            <tr>
                                <td colSpan="6" className="text-center text-muted py-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            <>
                                {datas.map((data, index) => {
                                    const holdDetails = JSON.parse(data.hold_details);

                                    // Get dates array from the last object in holdDetails
                                    const lastDates = holdDetails[holdDetails.length - 1].date;

                                    const lastreason = holdDetails[holdDetails.length - 1].reason;

                                    // Date formatter function (d-M-Y)
                                    const formatDate = (dateStr) => {
                                        const dateObj = new Date(dateStr);
                                        const day = String(dateObj.getDate()).padStart(2, '0');
                                        const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(dateObj);
                                        const year = dateObj.getFullYear();
                                        return `${day}-${month}-${year}`;
                                    };

                                    return (
                                        <tr key={data.sno}>
                                            <td>
                                                <div className='text-black font-w400 fs-7 text-wrap mw-auto'>{capitalizeFirstLetter(data.lead_name)}</div>
                                                <div className='d-block'>
                                                    <div className='text-dark font-w500 fs-8'>{data.lead_mobile_no}</div>
                                                </div>
                                            </td>

                                            <td>
                                                <div className="d-flex align-items-center justify-content-start gap-2">
                                                    <LightGallery
                                                        onInit={onInit}
                                                        speed={500}
                                                        plugins={[lgThumbnail, lgZoom]}
                                                    >
                                                        <div data-src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : lunch_box} className='border rounded px-1 py-0'>
                                                            <img src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : lunch_box} alt={data.product_name} className='cursor-pointer w-45px h-45px' />
                                                        </div>
                                                    </LightGallery>
                                                    <div className='mb-0'>
                                                        <label className='text-black font-w400 fs-7'>{data.product_name}</label>
                                                        <div className="d-block">
                                                            <div className="fs-8 font-w600 text-dark">{data.timeline_name} ({data.timeline_days} Days)</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'>Start Date</Tooltip>}>
                                                    <label className='text-success fw-bold fs-7'>{formatDate(data.start_date)}</label>
                                                </OverlayTrigger>
                                                <div className='d-block'>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement='bottom' overlay={<Tooltip className='toltip-popover'>End Date</Tooltip>}>
                                                        <label className='text-danger fw-bold fs-7'>{formatDate(data.end_date)}</label>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>

                                            <td>
                                                <div className="d-flex flex-wrap gap-2">
                                                    {lastDates.map((date, idx) => (
                                                    <React.Fragment key={idx}>
                                                        <label className="text-info fw-bold fs-7" style={{ minWidth: 'fit-content' }}>
                                                        {formatDate(date)}
                                                        </label>
                                                        {idx < lastDates.length - 1 && <span>,&nbsp;</span>}
                                                    </React.Fragment>
                                                    ))}
                                                </div>
                                            </td>

                                            <td className='text-start'>
                                                <div className='text-black font-w400 fs-7 text-wrap mw-auto'>{lastreason}</div>
                                            </td>

                                            <td>
                                                {data.hold_type === 1 && (
                                                    <Dropdown drop="">
                                                        <Dropdown.Toggle as="a" className={`i-false cursor-pointer`}>  
                                                            <Badge bg="none" className='py-1 px-2 fs-8 text-black' style={{ background: '#f4d03f' }}>Waiting For Approval</Badge>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu >
                                                            <Dropdown.Item href="#" className='text-black' onClick={()=> status_approve(data)}>Approve</Dropdown.Item>
                                                            <Dropdown.Item href="#" className='text-black' onClick={()=>status_cancel(data)}>Cancel</Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                )}

                                                {data.hold_type === 2 && (
                                                    <Badge bg="danger" className='py-1 px-2 fs-8 text-white' >Cancelled</Badge>
                                                )}

                                                {data.hold_type === 3 && (
                                                    <Badge bg="success" className='py-1 px-2 fs-8 text-white' >Approved</Badge>
                                                )}
                                            </td>
                                            
                                        </tr>
                                    );
                                })}
                            </>
                        )}

                        
                    </tbody>
                </table>

                <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {datas.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {totalPages * perPage - (perPage - datas.length)} entries
                            </span>
                        ):(
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            
            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Hold Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Products</label>
                                <Select placeholder="Select Product"
                                    value={productsOpt.find(option => option.value === filter_prods_id) || null}
                                    options={productsOpt}
                                    onChange={(selectedOption) => setFilterProdsID(selectedOption.value)}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Timeline</label>
                                <Select placeholder="Select Timeline"
                                    value={timelineoptions.find(option => option.value === filter_tline_id) || null}
                                    options={timelineoptions}
                                    onChange={(selectedOption) => setFilterTlineID(selectedOption.value)}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Area</label>
                                <Select placeholder="Select Area"
                                    value={areaOption.find(option => option.value === area) || null}
                                    options={areaOption}
                                    onChange={(selectedOption) => setArea(selectedOption.value)}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Delivery Point</label>
                                <Select placeholder="Select Delivery Point"
                                    value={dppoption.find(option => option.value === dp) || null}
                                    options={dppoption}
                                    onChange={(selectedOption) => setDp(selectedOption.value)}
                                />
                            </div>

                            {/* <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )} */}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1 mb-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={() =>{
                            setFilterProdsID(null);
                            setFilterTlineID(null);
                            setDateFilSeltValue('all');
                            setArea(null);
                            setDp(null);
                            fetchData();
                            onClose();
                            // window.location.reload();
                        }}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>

        </>
    )


}
export default Hold;